<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-pray'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle v-if="!isStatusEmpty" class="caption">信仰する宗教の有無</v-list-item-subtitle>
      <v-list-item-title>{{ printStatus }}</v-list-item-title>
      <v-list-item-subtitle v-if="isStatusYes" class="caption">{{ printName }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-radio-group required row
          v-model="form.status"
          :rules="rules.status"
          label="信仰している宗教はありますか？"
          @change="changed">
          <v-radio v-for="(item, idx) in getStatusItems" :key="`religion_status_${idx}`"
            color="blue darken-2"
            :label="item"
            :value="item"
          />
        </v-radio-group>
      </v-col>
      <v-col v-if="isFormStatusYes" cols="12" class="px-3">
        <v-text-field
          v-model="form.name"
          label="宗教名"
          counter="50"
          :rules="rules.name"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsHomestayReligion',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'religion',
        datepicker: {
          publish: false,
          expire: false
        }
      },
      meta: {
        status: [ 'はい', 'いいえ', ]
      },
      form: {
        id: '',
        status: '',
        name: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        name: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: `${dt.id || ''}`,
          status: dt.status || '',
          name: dt.name || ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: `${this.$props.data.id || ''}`,
          name: this.$props.data.name || ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: this.config.type
        }
      })
    },
    changed: function () {
      if (this.form.status !== 'はい') {
        this.prepare({
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.form.status || '',
          name: this.form.name || ''
        })
      }
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === this.config.type)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.config.type
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.config.type
      )
    },
    isStatusYes () {
      return !!(
        this.$props.data &&
        this.$props.data.status === 'はい'
      )
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'はい'
      )
    },
    getStatusItems () {
      return this.meta.status
    },
    isStatusEmpty () {
      return !(this.$props.data && this.$props.data.status)
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status
      ) ? this.$props.data.status : '宗教の回答'
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name
      ) ? this.$props.data.name : ''
    },
    isNameEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.name
      )
    }
  }
}
</script>
